// Descrições de picking geradas automaticamente seguem o padrão
// "{texto editável} | {placa} - {motorista} - {data prevista}".
// A parte a partir do pipe é fixa: o usuário só pode editar o que está à esquerda dele.

// Retorna o sufixo fixo (do pipe em diante) quando a descrição segue o padrão,
// ou null quando a descrição é livre (sem pipe / fora do padrão)
export function getSufixoFixoDescricaoPicking(name) {
  if (!name) return null

  const pipeIndex = name.indexOf('|')
  if (pipeIndex === -1) return null

  const sufixo = name.substring(pipeIndex)
  const padrao = /^\|[^|]+ - [^|]+ - \d{2}\/\d{2}\/\d{4}\s*$/
  return padrao.test(sufixo) ? sufixo : null
}

// Valida se o novo valor digitado mantém o sufixo fixo intacto
export function descricaoMantemSufixoFixo(novoValor, sufixoFixo) {
  if (!sufixoFixo) return true
  return typeof novoValor === 'string' && novoValor.endsWith(sufixoFixo)
}
